import { render, staticRenderFns } from "./_Payment.vue?vue&type=template&id=3fbef133&scoped=true"
import script from "./_Payment.vue?vue&type=script&lang=js"
export * from "./_Payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbef133",
  null
  
)

export default component.exports